import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, ChevronDown, Phone, UserRoundPlus, Users } from 'lucide-react';
import { Button } from '@/components/ui';

/**
 * «تسجيل حساب جديد» في صفحة الدخول (قرار صاحب المنصة 5 أكتوبر 2026).
 *
 * كانت الصفحةُ تعرض أربعةَ أبوابٍ بأزرارها دفعةً واحدة (`EntryGuide`) فازدحمت تحت نموذج الدخول.
 * صار بابٌ واحد: زرٌّ يفتح **ثلاثة** خيارات بصفة القارئ — مهني · وليّ أمر · مستفيد — ولا شيءَ منها
 * قبل الضغط. **وتسجيلُ المراكز ليس هنا**: ضمُّ المركز طلبٌ رسميٌّ بابُه الصفحةُ الأولى والترويسة
 * (`/register/center`)، لا خيارٌ لشخصٍ يسجّل نفسه (قرار 24 سبتمبر 2026 يمتدّ إلى الدخول).
 */
const CHOICES = [
  { key: 'professional', icon: Briefcase, title: 'مهني', who: 'أخصائي أو مرشد أو معلّم أو مدرّب — حسابٌ باسمي ينتقل معي.', to: '/register/professional' },
  { key: 'guardian', icon: Users, title: 'وليّ أمر', who: 'لي طفلٌ في مدرسة أو مركز، أو أريد إضافة طفلي وربطه بمؤسسته.', to: '/register/guardian' },
  { key: 'client', icon: Phone, title: 'مستفيد', who: 'أطلب خدمةً لنفسي برقم جوالي — لا طفلَ لي هنا.', to: '/client-login' },
] as const;

export function RegisterCta() {
  const [open, setOpen] = useState(false);
  return (
    <section className="reg-cta" aria-label="تسجيل حساب جديد" data-testid="register-cta">
      <Button
        variant="secondary" block icon={<UserRoundPlus size={17} />}
        aria-expanded={open} aria-controls="reg-cta-choices"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="reg-cta__label">تسجيل حساب جديد</span>
        <ChevronDown size={16} aria-hidden className={`reg-cta__chev${open ? ' is-open' : ''}`} />
      </Button>
      {open && (
        <div id="reg-cta-choices" className="reg-cta__panel">
          <p className="caption reg-cta__lead">أنا…</p>
          <ul className="reg-cta__list">
            {CHOICES.map((c) => (
              <li key={c.key}>
                <Link to={c.to} className="reg-cta__item" data-testid={`register-as-${c.key}`}>
                  <c.icon size={18} aria-hidden className="reg-cta__icon" />
                  <span className="reg-cta__body">
                    <strong className="reg-cta__name">{c.title}</strong>
                    <span className="reg-cta__who">{c.who}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <p className="caption reg-cta__staff">موظفٌ في مدرسة أو مركز؟ حسابَك تنشئه إدارةُ مؤسستك وتدخل به من هذه الصفحة.</p>
        </div>
      )}
    </section>
  );
}
